import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Typography} from '~library/atoms/Typography';
import {MessageInput} from '~/CreateFabricGreetingCard/routes/RecipientsMessage/components/MessageInput/MessageInput';
import {saveEventThunk} from '~/CreateFabricGreetingCard/api/event';
import './GlobalMessage.sass';

export const GlobalRecipientsMessage = ({onMessageChange, message}) => {
  const dispatch = useDispatch();

  const onDoneMessageClick = useCallback(async () => {
    await dispatch(saveEventThunk(true));
  }, [dispatch]);

  return (
    <div
      id="global-message"
      className="global-recipients-message"
      data-qa-id="global-recipients-message"
    >
      <Typography variant="header1" classNames="global-recipients-message__header">
        Global Message
      </Typography>
      <Typography variant="paragraph2" classNames="global-recipients-message__paragraph">
        Add a preset message to send to all recipients. You can edit individual messages below.
      </Typography>
      <MessageInput
        dataQaId="global-message"
        onDoneClick={onDoneMessageClick}
        onMessageChange={onMessageChange}
        message={message}
        initialState={!message}
      />
    </div>
  );
};
